import Axios from '../lib/axios'
import store from '@/store'

class EventService {
  async all (patientId) {
    const result = await Axios.authenticated().get(`/events/${patientId}`, {})
    return result
  }

  async create (event) {
    let newEvent = JSON.parse(event.get('event'))
    console.log('newEvent', newEvent)
    console.log('event', event)
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total)
    }
    const result = await Axios.authenticated().post(
      `/events/${newEvent.patientId}`,
      event,
      config
    )
    return result
  }
  async update (event) {
    let newEvent = event
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total)
    }
    const result = await Axios.authenticated().put(
      `/events/${newEvent.patientId}`,
      event,
      config
    )
    return result
  }

  async updateMedia (event) {
    let newEvent = JSON.parse(event.get('event'))
    const result = await Axios.authenticated().put(
      `/events/${newEvent.patientId}/media`,
      event
    )
    return result
  }

  async updatePeriodic (event) {
    const result = await Axios.authenticated().put(
      `/events/${event.patientId}?periodic=true`,
      event
    )
    return result
  }

  async delete (event) {
    const result = await Axios.authenticated().delete(`/events/${event.patientId}`, { data: { event: event } })
    return result
  }

  async deletePeriodic (event) {
    const result = await Axios.authenticated().delete(`/events/${event.patientId}?periodic=true`, { data: { event: event } })
    return result
  }
}

export default new EventService()
